import { browserTracingIntegration, init } from '@sentry/react';
import { excludeGraphQLFetch } from 'apollo-link-sentry';
import { isApolloStoreResetEvent } from './utils/is-apollo-store-reset-event.ts';
import { isClientNetworkFailure } from './utils/is-network-error.ts';

export const initSentry = () => {
  init({
    dsn: 'https://bea29d59e21c0a1bdf6569c6499f7e9a@o4505956381687808.ingest.us.sentry.io/4507698594512896',
    tracesSampleRate: 0.1,
    environment: import.meta.env.MODE,
    integrations: [browserTracingIntegration()],
    beforeBreadcrumb: excludeGraphQLFetch,
    beforeSend: (event, hint) => {
      if (
        isClientNetworkFailure(hint.originalException) ||
        isApolloStoreResetEvent(event)
      ) {
        return null;
      }

      return event;
    },
  });
};
